import styled from 'styled-components';

import { basicSmallTextStyle, StrongText } from '@dreryk/react-components';

export const StyledStageHeaderTitle = styled(StrongText)`
   ${basicSmallTextStyle};
   color: ${({ theme }) => theme.borderDark};
`;

StyledStageHeaderTitle.displayName = 'StyledStageHeaderTitle';
